import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { PostsPage } from "@/components/dashboard/posts/PostsPage";

const postsSearchSchema = z.object({
	view: z.enum(["list", "calendar"]).optional().catch(undefined),
	postId: z.string().optional().catch(undefined),
	page: z.coerce.number().int().min(1).optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/posts")({
	component: PostsPage,
	validateSearch: (search) => postsSearchSchema.parse(search),
	beforeLoad: ({ search }) => {
		if (search.view === "calendar") {
			throw redirect({ to: "/dashboard/calendar" });
		}
	},
});
